'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function ($, window) {
  var _buttons;

  $(function () {
    $.fn.dataTable.ext.buttons.print.text = '<i class="ion ion-printer"></i>';
    $.fn.dataTable.ext.buttons.reset.text = '<i class="ion ion-reply"></i>';
    $.fn.dataTable.ext.buttons.reload.text = '<i class="ion ion-refresh"></i>';

    $(document.body).on('mouseenter', 'tbody > tr > td [title]', function () {
      var el = $(this);
      if (el.data('tooltip') === undefined) {
        el.tooltip({
          placement: el.data('placement') || 'top',
          container: document.body
        });
      }
      el.tooltip('show');
    });

    $('body').on('mouseleave', '[rel=tooltip]', function () {
      $(this).tooltip('hide');
    });
  });

  function init(table) {
    table.one('init', function () {
      _.each(buttons, function (title, name) {
        setTooltip(name, title, table);
        $('.dataTables_length select, tfoot select').select2({
          language: "pt-BR",
          allowClear: false,
          minimumResultsForSearch: Infinity,
          dropdownCssClass: 'table-select'
        });
      });
    });
  }

  var buttons = (_buttons = {
    print: 'Imprimir',
    export: 'Exportar',
    reset: 'Redefinir',
    reload: 'Atualizar'
  }, _defineProperty(_buttons, 'export', 'Exportar'), _defineProperty(_buttons, 'colvis', 'Exibir/Ocultar Colunas'), _buttons);

  function setTooltip(name, title, table) {
    table.buttons('.buttons-' + name).nodes().tooltip({
      container: 'body',
      delay: {
        show: 800,
        hide: 300
      },
      placement: 'bottom',
      title: title,
      trigger: 'hover',
      template: '<div class="tooltip tooltip-custom" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
    });
  }

  window.datatablesCustomInitFunction = init;
})(jQuery, window);